<template lang="html">
  <div>
    <connector-component
      v-for="connector in connectors"
      :key="connector.id"
      :connector="connector"
      @clicked="onClickChild"
    />
  </div>
</template>

<script lang="ts" setup>
import ConnectorComponent from "@/components/ui/ConnectorComponent"
import type { Connector } from "@/models/common"

interface ConnectorsComponentProps {
  connectors: Connector[]
}

withDefaults(defineProps<ConnectorsComponentProps>(), {
  connectors: () => []
})

const emit = defineEmits(["connectorselected"])

const onClickChild = (obj: Connector) => {
  emit("connectorselected", obj)
}
</script>
